import * as React from "react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function InteriorHero() {
  return <section id="interiorremodelinghero" data-nav="light" className="relative overflow-hidden bg-background text-foreground pt-28 pb-16 md:pt-36 md:pb-24 lg:pt-40 lg:pb-28">
      {/* 4D Isometric Glass Subtle Background Accents */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[42rem] h-[22rem] rounded-full bg-chart-1/5 blur-3xl" />
        <div className="absolute top-12 right-[-5%] w-96 h-96 rounded-full bg-chart-2/5 blur-2xl" />
        <div className="absolute bottom-0 left-[-5%] w-80 h-80 rounded-full bg-secondary/70 blur-xl" />
      </div>

      <div className="relative z-10 mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-border/80 bg-card/75 p-8 shadow-sm backdrop-blur-md sm:p-12 md:p-16 lg:p-20">
          {/* Breadcrumb Navigation */}
          <div className="mb-6 md:mb-8">
            <Breadcrumb>
              <BreadcrumbList className="text-xs sm:text-sm text-muted-foreground font-medium">
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/" className="text-muted-foreground hover:text-foreground transition-colors">
                      Home
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <span className="text-muted-foreground">Services</span>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage className="font-semibold text-foreground">
                    Interior Remodeling
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>

          {/* Heading and Intro Content */}
          <div className="max-w-3xl space-y-5 md:space-y-6">
            <h1 className="font-serif text-3xl font-semibold tracking-tight text-foreground sm:text-4xl md:text-5xl lg:text-6xl leading-[1.12]">
              Interior Remodeling in Decatur, GA
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
              From open-concept structural reconfigurations and custom millwork to full-floor living transformations, we renovate historic and modern Decatur homes with meticulous architectural craftsmanship and enduring materials.
            </p>
          </div>
        </div>
      </div>
    </section>;
}